export default __webpack_public_path__ + "static/screeny-150-storm-scheda-tecnica-880eb885632eb4a2497598470f5bc6c1.pdf";